export default [
  {
    path: 'unify-challenge/:orgURL?',
    name: 'landing-unify-challenge-view',
    component: () => import('@/views/landing/LandingPage.vue'),
    props: {
      eventType: 'unify-challenge',
    },
    meta: {
      bypassAuth: true,
      renderNav: false,
      title: 'Landing Page - Unify Challenge',
      // renderHeader: false,
    },
  },
  {
    path: 'deep-dive/:orgURL?',
    name: 'landing-deep-dive-view',
    component: () => import('@/views/landing/LandingPage.vue'),
    props: {
      eventType: 'deep-dive',
    },
    meta: {
      bypassAuth: true,
      renderNav: false,
      title: 'Landing Page - Deep Dive',
      // renderHeader: false,
    },
  },
];